if (!customElements.get('component-product-discount')) {
  customElements.define('component-product-discount', class ProductDiscount extends HTMLElement {
    constructor() {
      super();
      this.copyDiscountCode = this.querySelector('.copy-discount-code');
      this.copidDiscountCode = this.querySelector('.copied');
      this.copyCode = this.querySelector('.code');
      if(this.copyDiscountCode){
        this.copyDiscountCode.addEventListener('click', this.onCopyDiscountCode.bind(this));
      }
    }

    onCopyDiscountCode(){
      let codeText = this.copyCode.innerText;
      this.toCopy(codeText)
      this.copyDiscountCode.style.display = 'none'
      this.copidDiscountCode.style.display = 'block'
    }
    toCopy(text) {
        text = String(text);
        let input = document.createElement('input');
        input.style.opacity  = 0;
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.value = text;
        input.select();
        input.setSelectionRange(0, text.length);
        document.execCommand('copy');
        document.body.removeChild(input);
    }
  }
)};